export const CREATE_FILLED_APTITUDE_TEST_ATTEMPT = 'CREATE_FILLED_APTITUDE_TEST_ATTEMPT';
export type CREATE_FILLED_APTITUDE_TEST_ATTEMPT = typeof CREATE_FILLED_APTITUDE_TEST_ATTEMPT;

export const CREATE_FILLED_APTITUDE_TEST_SUCCESS = 'CREATE_FILLED_APTITUDE_TEST_SUCCESS';
export type CREATE_FILLED_APTITUDE_TEST_SUCCESS = typeof CREATE_FILLED_APTITUDE_TEST_SUCCESS;

export const CREATE_FILLED_APTITUDE_TEST_FAILURE = 'CREATE_FILLED_APTITUDE_TEST_FAILURE';
export type CREATE_FILLED_APTITUDE_TEST_FAILURE = typeof CREATE_FILLED_APTITUDE_TEST_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/filled-test/create/Types.tsx